/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './procedure-blood-products.reducer';

export const ProcedureBloodProductsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const procedureBloodProductsEntity = useAppSelector(state => state.procedureBloodProducts.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="procedureBloodProductsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.detail.title">ProcedureBloodProducts</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.id">Id</Translate>
            </span>
          </dt>
          <dd>{procedureBloodProductsEntity.id}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.type">Type</Translate>
            </span>
          </dt>
          <dd>{procedureBloodProductsEntity.type}</dd>
          <dt>
            <span id="timeAdministered">
              <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.timeAdministered">Time Administered</Translate>
            </span>
          </dt>
          <dd>{procedureBloodProductsEntity.timeAdministered}</dd>
          <dt>
            <span id="doseAdministered">
              <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.doseAdministered">Dose Administered</Translate>
            </span>
          </dt>
          <dd>{procedureBloodProductsEntity.doseAdministered}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{procedureBloodProductsEntity.notes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.active">Active</Translate>
            </span>
          </dt>
          <dd>{procedureBloodProductsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{procedureBloodProductsEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{procedureBloodProductsEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{procedureBloodProductsEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{procedureBloodProductsEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.surgery">Surgery</Translate>
          </dt>
          <dd>{procedureBloodProductsEntity.surgery ? procedureBloodProductsEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.intraOPChart">Intra OP Chart</Translate>
          </dt>
          <dd>{procedureBloodProductsEntity.intraOPChart ? procedureBloodProductsEntity.intraOPChart.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureBloodProducts.recoveryRecord">Recovery Record</Translate>
          </dt>
          <dd>{procedureBloodProductsEntity.recoveryRecord ? procedureBloodProductsEntity.recoveryRecord.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/procedure-blood-products" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/procedure-blood-products/${procedureBloodProductsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProcedureBloodProductsDetail;
